
import React from 'react';
import { Container, Row } from "react-bootstrap";
import PropTypes from 'prop-types';
import './About.scss';


export default function About(props) {
  return (
    <Container fluid className="white-section about w-100">
      { props.title && <Row className="justify-content-center">
        <h2 className="text-center mb-3">{props.title}</h2>
      </Row> }
      { props.content && <Row className="justify-content-center">
        <p className="text-center">{props.content}</p>
      </Row> }
      { props.disclaimer &&
      <Row className="justify-content-center disclaimer">
        <p>{props.disclaimer}</p>
      </Row>
      }
    </Container>
  );
};

About.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string,
  disclaimer: PropTypes.string,
};
